import React from 'react';
import PropTypes from 'prop-types';
import { TabContent, TabPane } from 'reactstrap';

import CollectedDetails from './CollectedDetails';

const PageDetailsTabContent = ({ activeTab, pageId }) => (
  <TabContent activeTab={activeTab} className="settings-tab-content">
    <TabPane tabId="collected-details">
      <CollectedDetails
        pageId={pageId}
      />
    </TabPane>
  </TabContent>
);

PageDetailsTabContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
};

export default PageDetailsTabContent;
